<template>
  <div class="container" id="information">
    <div v-if="scholarship" :class="scholarship.organization.canonical_name">
      <h1>About {{scholarship.organization.organization_name}}</h1>
      <div>
        <section v-html="scholarship.organization.description"></section>
      </div>
      <h1>About {{scholarship.name}}</h1>
      <div>
        <section v-html="scholarship.description"></section>
      </div>
      <div v-if="scholarship.active">
        <h3> Applications cannot be submitted after the deadline: {{scholarship.active.close}} </h3>
      </div>
      <div v-else>
        <h3> No Active Enrollment Period </h3>
      </div>
    </div>
      <router-link :to="{ name: 'requirements',
          params: { organization_name: $route.params.organization_name,
            scholarship_name: $route.params.scholarship_name }}">
            <div v-if="scholarship" :class="scholarship.organization.canonical_name">
              <button class="btn btn-primary">Requirements</button>
            </div>
      </router-link>
  </div>
</template>

<script>
// import Login from '../users/Login.vue'
import axios from '../../auth';
export default {
  data(){
    return {
      scholarship: null,
      msg: ""
    }
  },
  mounted(){
    if (this.$route.query.notify) {
      this.$toasted.success(this.$route.query.notify,
        {
          position: "bottom-right",
          duration: 10000
        })
    }
    axios.get(`${process.env.VUE_APP_ENDPOINT}/api/${this.$route.params.organization_name}/${this.$route.params.scholarship_name}/`)
    .then(res => {
      this.scholarship = res.data
    })
    .catch(err=>{
      this.msg = err
      if( err.response && err.response.status === 404 ){
        this.$router.push({path: "/notFound"})
      }
    })
  }
}
</script>

<style>

</style>
